export default "__VITE_ASSET__DHcl$lmR__"